import React from 'react';
import { IconButton } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import GitHubIcon from '@mui/icons-material/GitHub';
import "../styles/Footer.css";

const Footer = () => {
  const linkedinUrl = 'https://www.linkedin.com/in/andres-tanesini/';
  const emailAddress = "andres.tanesini94@gmail.com";
  const githubUrl = 'https://github.com/tane994';

  const handleEmailClick = () => {
    const mailtoLink = `mailto:${emailAddress}`;
    window.open(mailtoLink);
  };

  return (
    <div className="footer">
      <div className='socialMediaFooter'>
        <IconButton href={linkedinUrl} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
          <LinkedInIcon />
        </IconButton>
        <IconButton onClick={handleEmailClick} aria-label="Email">
          <AlternateEmailIcon />
        </IconButton>
        <IconButton href={githubUrl} target="_blank" rel="noopener noreferrer" aria-label="GitHub">
          <GitHubIcon />
        </IconButton>
      </div>
      <p>&copy; 2024 andrestanesini.com</p>
    </div>
  )
}

export default Footer;